import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MainContent from "../component/dashboard/MainContent";
const Navbar = () => {
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate();

  return (
    <div >
      {/* Main Content */}
      <div className="flex-1 flex flex-col">
        {/* Main Content */}
        <MainContent />
      </div>
    </div>
  );
};

export default Navbar;
